import ReactDiffViewer from "react-diff-viewer-continued";

import { DeviceConfigurationDiff } from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface ConfigDiffViewProps {
  configDiff: DeviceConfigurationDiff;
}

export const ConfigDiffView: React.FC<ConfigDiffViewProps> = ({
  configDiff
}) => {
  if (!configDiff) return null;

  return (
    <ReactDiffViewer
      oldValue={JSON.stringify(configDiff.desiredConfig, null, 4)}
      newValue={JSON.stringify(configDiff.reportedConfig, null, 4)}
      splitView={true}
    />
  );
};
